module.exports = __webpack_public_path__ + "img/ic_head_hight_1.1c187395.png";